<template>

  <div>
    <user-list-add-new :is-add-new-user-sidebar-active.sync="isAddNewUserSidebarActive" :role-options="roleOptions"
      :plan-options="planOptions" @refetch-data="refetchData" />
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">

      <div class="m-2">

        <!-- Table Top -->
        <b-row>

          <!-- Per Page -->
          <b-col cols="12" md="5" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ $t('Show') }}</label>
            <v-select v-model="perPage" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :options="perPageOptions"
              :clearable="false" class="per-page-selector d-inline-block mx-50" />
            <label>{{ $t('entries') }}</label>
          </b-col>
          
          <!-- Search -->
          <b-col cols="12" md="3">
            <b-button v-if="isRedirectionRouteActive" variant="outline-warning" @click="goToRedirectionPath()">
              {{ $t('Go Back to Course Detail') }}
            </b-button>
          </b-col>
          <b-col cols="12" md="4">
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input v-model="searchQuery" class="d-inline-block mr-1" :placeholder="$t('Search...')" />
              <b-button variant="primary" @click="isAddNewUserSidebarActive = true">
                <span class="text-nowrap">{{ $t("Add Certificate") }}</span>
              </b-button>
            </div>
          </b-col>
        </b-row>

      </div>
      <!-- <b-row  class="d-flex justify-content-end">
        <b-col cols="12" md="3" class="d-flex align-items-center justify-content-end mb-1 mb-0 mr-1">
            <b-form-checkbox id="checkbox-1" v-model="byDepartment" name="checkbox-1" :value="false"
              :unchecked-value="false">
              {{byDepartment? $t('By Department'): $t('All Departments')}}
            </b-form-checkbox>
          </b-col>
      </b-row> -->
      <b-table ref="refUserListTable" class="position-relative" :items="items" responsive :fields="tableColumns"
        primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No matching records found')"
        :filter="searchQuery" :sort-desc.sync="isSortDirDesc" :per-page="perPage" :current-page="currentPage"
        @filtered="onFiltered">

        <template #head()="data">
          <span class="text">{{ $t(data.label.toUpperCase()) }}</span>
        </template>
        <template #cell(title)="data">

          <b-link :to="{ name: 'apps-certificate-edit', params: { id: data.item.id }, query: { id: data.item.id } }"
            class="font-weight-bold d-block text-nowrap">
            {{ data.item.title }}
          </b-link>
        </template>

        <template #cell(actions)="data">
          <b-button size="sm" variant="outline-danger" class="mr-1" @click="deleteCertificate(data.item.id)">
            <feather-icon icon="TrashIcon" size="16" />
          </b-button>

        </template>

      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
            <span class="text-muted">{{ $t('Showing') }} {{ dataMeta.from }} {{ $t('to') }} {{ dataMeta.to }} {{
              $t('of') }}
              {{ dataMeta.of }}
              {{ $t('entries') }}</span>
          </b-col>
          <!-- Pagination -->
          <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">

            <b-pagination v-model="currentPage" :total-rows="totalUsers" :per-page="perPage" first-number last-number
              class="mb-0 mt-1 mt-sm-0" prev-class="prev-item" next-class="next-item">
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { useRedirectionRoute } from '@/@core/comp-functions/routing/useRedirectionRoute'
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination,BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted, computed } from '@vue/composition-api'
import router from '@/router'
import { avatarText } from '@core/utils/filter'
import UsersListFilters from './CertificatesListFilters.vue'
import useUsersList from './useCertificatesList'
import userStoreModule from '../certificateStoreModule'
import UserListAddNew from './CertificateListAddNew.vue'

export default {

  methods: {
    onFiltered(filteredItems) {
      this.totalUsers = filteredItems.length
      this.currentPage = 1
    },
  },
  components: {
    UsersListFilters,
    UserListAddNew,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    vSelect,
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'apps-certificate'

    // Register module
    if (!store.hasModule(USER_APP_STORE_MODULE_NAME)) store.registerModule(USER_APP_STORE_MODULE_NAME, userStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })

    const isAddNewUserSidebarActive = ref(false)


    const roleOptions = [
      { label: 'Admin', value: 'admin' },
      { label: 'Author', value: 'author' },
      { label: 'Editor', value: 'editor' },
      { label: 'Maintainer', value: 'maintainer' },
      { label: 'Subscriber', value: 'subscriber' },
    ]

    const planOptions = [
      { label: 'Basic', value: 'basic' },
      { label: 'Company', value: 'company' },
      { label: 'Enterprise', value: 'enterprise' },
      { label: 'Team', value: 'team' },
    ]

    const statusOptions = [
      { label: 'Pending', value: 'pending' },
      { label: 'Active', value: 'active' },
      { label: 'Inactive', value: 'inactive' },
    ]



    const {
      fetchCertificates,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,

      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      deleteCertificate,
      items,
      itemsByDepartment,
      totalUsersByDepartment,
      byDepartment,
      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      resolveUserStatusVariantText,
      filterList,
      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    } = useUsersList()
    const { redirectionRoute, goToRedirectionPath, isRedirectionRouteActive } = useRedirectionRoute()

    return {

      // Sidebar
      items,
      isAddNewUserSidebarActive,

      fetchCertificates,
      tableColumns,
      perPage,
      currentPage,
      totalUsers,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      goToRedirectionPath,
      isRedirectionRouteActive,
      refUserListTable,
      refetchData,
      deleteCertificate,
      redirectionRoute,
      // Filter
      avatarText,
      itemsByDepartment,
      totalUsersByDepartment,
      byDepartment,
      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveUserStatusVariant,
      resolveUserStatusVariantText,
      filterList,

      roleOptions,
      planOptions,
      statusOptions,

      // Extra Filters
      roleFilter,
      planFilter,
      statusFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
